import { QueryClient, notifyManager } from '@tanstack/react-query'
import { ApiError } from './api'

// Query state reaches React in the same task that changed it, so a button disabled while its
// mutation is pending is already disabled when the second click of a double-click arrives.
notifyManager.setScheduler(queueMicrotask)

export function shouldRetryQuery(failureCount: number, error: unknown) {
  if (failureCount >= 2) return false
  if (!(error instanceof ApiError)) return true
  if (error.code === 'offline') return false
  return error.status === 0 || error.status >= 500
}

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        retry: shouldRetryQuery,
      },
      mutations: { retry: false },
    },
  })
}
